export const DESKTOP_WINDOW_SIZE = {
  width: 1600,
  height: 900,
};

export const MOBILE_WINDOW_SIZE = {
  width: 390,
  height: 800,
};

export const WINDOW_SCALE_FACTOR = 1.8;
